module.exports = __webpack_public_path__ + "img/chargers.649bf4d4.png";